import React, { useEffect, useRef, useState } from 'react';
import './project.css'
//  import { Swiper, SwiperSlide } from 'swiper/react';
import { motion } from "framer-motion";
import 'swiper/css/autoplay';
import project from '../../../img/dakzy-2.png';
import project1 from '../../../img/Myacebazar.png';
import project2 from '../../../img/pocket notess.png';
import project3 from '../../../img/FOT.png';
import project4 from '../../../img/girls slay.png';
import project5 from '../../../img/Athletenutirtion.png';
import { Link } from 'react-router-dom';

const Project = () => {

   const [visible2, setVisible2] = useState(false); // Challenges & Difficulties
   const heading2Ref = useRef();

   const letters2_line1 = ["O", "u", "r", "\u00A0", "L", "a", "t", "e", "s", "t", "\u00A0", "&", "\u00A0", "G", "r", "e", "a", "t",];
   const letters2_line2 = ["P", "r", "o", "j", "e", "c", "t", "s"];

   useEffect(() => {
      const observerOptions = { threshold: 0.3 };

      const createObserver = (setVisible, ref) => {
         const observer = new IntersectionObserver(
            ([entry]) => {
               if (entry.isIntersecting) {
                  setVisible(true);
                  observer.unobserve(ref.current);
               }
            },
            observerOptions
         );
         if (ref.current) observer.observe(ref.current);
      };


      createObserver(setVisible2, heading2Ref);


      return () => { }; // Cleanup skipped for simplicity
   }, []);


   const imageRefs = useRef([]);

   const lerp = (start, end, factor) => {
      return start + (end - start) * factor;
   };

   const updatePosition = () => {
      imageRefs.current.forEach((img) => {
         if (img) {
            const speed = parseFloat(img.dataset.speed) || 0.8;
            const rect = img.getBoundingClientRect();
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            const elementOffsetTop = rect.top + scrollTop;
            const targetY = (scrollTop - elementOffsetTop) * speed;

            if (!img.currentY) img.currentY = 0;
            img.currentY = lerp(img.currentY, targetY, 0.1);

            img.style.transform = `translateY(${img.currentY}px)`;
            img.style.willChange = 'transform';
         }
      });
      requestAnimationFrame(updatePosition);
   };

   useEffect(() => {
      requestAnimationFrame(updatePosition);
   }, []);



   const [position, setPosition] = useState({ x: 0, y: 0 });
   const [visible, setVisible] = useState(false);

   useEffect(() => {
      const moveCursor = (e) => {
         setPosition({ x: e.clientX, y: e.clientY });
      };

      const showCursor = () => setVisible(true);
      const hideCursor = () => setVisible(false);

      document.body.classList.add('tp-magic-cursor');
      window.addEventListener('mousemove', moveCursor);
      window.addEventListener('mouseenter', showCursor);
      window.addEventListener('mouseleave', hideCursor);

      return () => {
         document.body.classList.remove('tp-magic-cursor');
         window.removeEventListener('mousemove', moveCursor);
         window.removeEventListener('mouseenter', showCursor);
         window.removeEventListener('mouseleave', hideCursor);
      };
   }, []);


   const slides = [
      { id: 1, title: 'See More' },
      { id: 2, title: ' See More' },
      { id: 3, title: 'See More' },
      { id: 4, title: 'See More' },
      { id: 5, title: 'See More' },
   ];

   return (
      <>
         {/* Aggressive mobile overflow fix: prevent any horizontal scroll on mobile */}
         <style>{`
           @media (max-width: 767px) {
             body {
               overflow-x: hidden !important;
               width: 100vw !important;
               position: relative !important;
             }
             html {
               overflow-x: hidden !important;
               width: 100vw !important;
             }
             #root, .App, .container, .container-1560, .container-1630 {
               overflow-x: hidden !important;
               width: 100vw !important;
               max-width: 100vw !important;
               position: relative !important;
            }
           }
         `}</style>
         <div>
            <div
               id="magic-cursor-project"
               style={{
                  opacity: visible ? 1 : 0,
                  visibility: visible ? 'visible' : 'hidden',
               }}
            >
               <div
                  id="ball-project"
                  style={{
                     transform: `translate(-50%, -50%) translate(${position.x}px, ${position.y}px)`,
                  }}
               >
                  {/* Optional: Insert .ball-view, .ball-drag, etc. here */}
               </div>
            </div>



            <div id="smooth-wrapper">
               <div id="smooth-content">

                  <main className="container">

                     <div className="">

                        {/* <!-- hero area start --> */}
                        <div className="tm-hero-area tm-hero-ptb p-relative">
                           <div className="container">
                              <div className="row">
                                 <div className="col-xl-12">
                                    <div className="tm-hero-content">
                                       <span className="tm-hero-subtitle">CodeQlik</span>
                                       {/* <h4 className="tm-hero-title tp-char-animation">Our Latest & Great Projects</h4> */}
                                       <h4 ref={heading2Ref} className="showcase-details-2-section-title tp-char-animation">
                                          <span style={{ display: "inline-block" }}>
                                             {letters2_line1.map((letter, index) => (
                                                <span
                                                   key={`challenge1-${index}`}
                                                   className={`char ${visible2 ? "visible" : ""}`}
                                                   style={{ animationDelay: `${index * 0.1}s` }}
                                                >
                                                   {letter}
                                                </span>
                                             ))}
                                          </span>
                                          <br />
                                          <span style={{ display: "inline-block" }}>
                                             {letters2_line2.map((letter, index) => (
                                                <span
                                                   key={`challenge2-${index}`}
                                                   className={`char ${visible2 ? "visible" : ""}`}
                                                   style={{ animationDelay: `${(letters2_line1.length + index) * 0.1}s` }}
                                                >
                                                   {letter}
                                                </span>
                                             ))}
                                          </span>
                                       </h4>
                                    </div>
                                    <div className="tm-hero-text tp_title_anim">
                                       <p>
                                          We're a diverse team that works as fancies attention to
                                          details, enjoys beers on Friday nights and aspires to design
                                          the dent in the universe.
                                       </p>
                                    </div>
                                 </div>
                              </div>
                           </div>
                        </div>
                        {/* <!-- hero area end --> */}

                        {/* <!-- project area start --> */}
                        <div className="tp-project-area-2 fix">
                           <div className="tp-project-gallery-wrapper">
                              <div className="container container-1630">
                                 <div className="row">
                                    <div className="col-xl-6 col-lg-6 col-md-6">
                                       <div className="tp-project-left-wrap">

                                          {/* Dakzy Project */}
                                          <div className="text-detail">
                                             <h2>Dakzy</h2>
                                          </div>
                                          <div className="tp-project-item tp-project-mr m-100">
                                             <div className="tp-project-img height-1 fix not-hide-cursor" data-cursor="View<br>Demo" style={{ overflow: 'hidden' }}>
                                                <Link className="cursor-hide" to="/dakzy">
                                                   <img
                                                      ref={(el) => (imageRefs.current[0] = el)}
                                                      className="w-100"
                                                      data-speed=".8"
                                                      src={project}
                                                      alt=""
                                                      style={{ transform: 'translateY(0px)' }}
                                                   />
                                                </Link>
                                             </div>
                                          </div>

                                          {/* My Ace Bazar Project */}
                                          <div className="tp-project-item text-end mb-5 tp-project-left-text">
                                             <div className="text-detail">
                                                <h2>My Ace Bazar</h2>
                                             </div>
                                             <div className="tp-project-img height-2 d-inline-flex justify-content-end fix not-hide-cursor" data-cursor="View<br>Demo" style={{ overflow: 'hidden' }}>
                                                <Link className="cursor-hide" to="/myacebazar">
                                                   <img
                                                      ref={(el) => (imageRefs.current[1] = el)}
                                                      className="w-100"
                                                      data-speed=".8"
                                                      src={project1}
                                                      alt=""
                                                      style={{ transform: 'translateY(0px)' }}
                                                   />
                                                </Link>
                                             </div>
                                          </div>

                                          {/* My Pocket Notes Project */}
                                          <div className="tp-project-item text-end tp-project-left-text">
                                             <div className="text-detail">
                                                <h2>My Pocket Notes</h2>
                                             </div>
                                             <div className="tp-project-img height-3 d-inline-flex justify-content-end fix not-hide-cursor" data-cursor="View<br>Demo" style={{ overflow: 'hidden' }}>
                                                <Link className="cursor-hide" to="/mypocketnotres">
                                                   <img
                                                      ref={(el) => (imageRefs.current[2] = el)}
                                                      className="w-100"
                                                      data-speed=".8"
                                                      src={project2}
                                                      alt=""
                                                      style={{ transform: 'translateY(0px)' }}
                                                   />
                                                </Link>
                                             </div>
                                          </div>

                                       </div>
                                    </div>
                                    <div className="col-xl-6 col-lg-6 col-md-6">
                                       <div className="tp-project-right-wrap">


                                          {/* FOOD ON TIPS */}
                                          <div className="text-detail">
                                             <h2>FOOD ON TIPS</h2>
                                          </div>
                                          <div className="tp-project-item mb-200">
                                             <div className="tp-project-img height-4 fix not-hide-cursor" data-cursor="View<br>Demo" style={{ overflow: 'hidden' }}>
                                                <Link className="cursor-hide" to="/fot">
                                                   <img
                                                      ref={(el) => (imageRefs.current[3] = el)}
                                                      className="w-100"
                                                      data-speed=".8"
                                                      src={project3}
                                                      alt=""
                                                      style={{ transform: 'translateY(0px)' }}
                                                   />
                                                </Link>
                                             </div>
                                          </div>

                                          {/* Girls Slay */}
                                          <div className="tp-project-item tp-project-ml tp-project-left-text">
                                             <div className="text-detail">
                                                <h2>Girls Slay</h2>
                                             </div>
                                             <div className="tp-project-img height-5 fix not-hide-cursor" data-cursor="View<br>Demo" style={{ overflow: 'hidden' }}>
                                                <a className="cursor-hide" href="/Girlsslay">
                                                   <img
                                                      ref={(el) => (imageRefs.current[4] = el)}
                                                      className="w-100"
                                                      data-speed=".8"
                                                      src={project4}
                                                      alt=""
                                                      style={{ transform: 'translateY(0px)' }}
                                                   />
                                                </a>
                                             </div>
                                          </div>

                                          {/* Anthlete Nutrition */}
                                          <div className="tp-project-item tp-project-left-text">
                                             <div className="text-detail">
                                                <h2>Anthlete Nutrition</h2>
                                             </div>
                                             <div className="tp-project-img height-6 fix not-hide-cursor" data-cursor="View<br>Demo" style={{ overflow: 'hidden' }}>
                                                <Link className="cursor-hide" to="/anthlete">
                                                   <img
                                                      ref={(el) => (imageRefs.current[5] = el)}
                                                      className="w-100"
                                                      data-speed=".8"
                                                      src={project5}
                                                      alt=""
                                                      style={{ transform: 'translateY(0px)' }}
                                                   />
                                                </Link>
                                             </div>
                                          </div>

                                          <div className="tp-project-btn tp-btn-trigger tp-project-left-text">
                                             <div className="tp-btn-bounce">
                                                <a className="tp-btn-border" href="/contact">
                                                   <span className="tp-btn-border-wrap">
                                                      <span className="text-1">Contact Us</span>
                                                      <span className="text-2">Contact Us</span>
                                                   </span>
                                                </a>
                                             </div>
                                          </div>
                                       </div>
                                    </div>
                                 </div>
                              </div>
                           </div>
                        </div>
                        {/* <!-- project area end --> */}

                     </div>

                    
                     <div className="marquee-wrapper">
                        <div className="marquee-track">
                           {slides.concat(slides).map((slide, index) => (
                              <div className="marquee-item" key={index}>
                                 <h4 className="flex items-center gap-2 svg-text">
                                    <span className="hidden md:inline-block svg-text-icon">
                                       {/* Your SVG icon */}
                                       <svg width="70" height="70" viewBox="0 0 70 70" xmlns="http://www.w3.org/2000/svg" fill="none">
                                          {/* <!-- Bigger orbital paths --> */}
                                          <g stroke="white" stroke-width="1.5">
                                             <ellipse cx="35" cy="35" rx="30" ry="20" transform="rotate(45 35 35)" />
                                             <ellipse cx="35" cy="35" rx="30" ry="20" transform="rotate(-45 35 35)" />
                                          </g>

                                          {/* <!-- Central sparkle/star --> */}
                                          <path d="M35 22
           C37 28, 43 33.5, 49 35
           C43 36.5, 37 42, 35 48
           C33 42, 27 36.5, 21 35
           C27 33.5, 33 28, 35 22Z" fill="white" />
                                       </svg>

                                    </span>

                                    {slide.title}
                                 </h4>
                              </div>
                           ))}
                        </div>
                     </div>

                     {/* <!-- project area start --> */}

                     {/* <!-- contact area start --> */}
                     <div className="rm-project-contact-area pb-120">
                        <div className="container">
                           <div className="row justify-content-center">
                              <div className="col-xl-10">
                                 <div className="rm-project-contact-content mb-40">
                                    <span className="tm-hero-subtitle">CONTACT</span>
                                 </div>
                              </div>
                           </div>
                           <div className="row justify-content-center">
                              <div className="col-xl-10">
                                 <div className="rm-project-contact-wrap">
                                    <a href="/contact" className="text-decoration-none">
                                       <div className="rm-project-contact-item d-flex align-items-center justify-content-between">
                                          <span>Have a project?</span>
                                          <svg width="46" height="46" viewBox="0 0 46 46" fill="none" xmlns="http://www.w3.org/2000/svg">
                                             <path d="M1.7868 23.0003H44.2132" stroke="currentcolor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" />
                                             <path d="M23 1.78711L44.2132 23.0003L23 44.2135" stroke="currentcolor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" />
                                          </svg>
                                       </div>
                                    </a>
                                    <a href="/contact" className="text-decoration-none">
                                       <div className="rm-project-contact-item d-flex align-items-center justify-content-between">
                                          <span>Email us</span>
                                          <svg width="46" height="46" viewBox="0 0 46 46" fill="none" xmlns="http://www.w3.org/2000/svg">
                                             <path d="M1.7868 23.0003H44.2132" stroke="currentcolor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" />
                                             <path d="M23 1.78711L44.2132 23.0003L23 44.2135" stroke="currentcolor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" />
                                          </svg>
                                       </div>
                                    </a>
                                    <a href="/careers" className="text-decoration-none">
                                       <div className="rm-project-contact-item d-flex align-items-center justify-content-between">
                                          <span>Join our team</span>
                                          <svg width="46" height="46" viewBox="0 0 46 46" fill="none" xmlns="http://www.w3.org/2000/svg">
                                             <path d="M1.7868 23.0003H44.2132" stroke="currentcolor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" />
                                             <path d="M23 1.78711L44.2132 23.0003L23 44.2135" stroke="currentcolor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" />
                                          </svg>
                                       </div>
                                    </a>
                                 </div>
                              </div>
                           </div>
                        </div>
                     </div>

                  </main>


               </div>
            </div>
         </div>
      </>
   )
}

export default Project
 